var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogout04 = function SvgLogout04(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76471 5.20039V3.80039C9.76471 3.42909 9.61597 3.07299 9.35121 2.81044C9.08645 2.54789 8.72736 2.40039 8.35294 2.40039H3.41176C3.03734 2.40039 2.67825 2.54789 2.4135 2.81044C2.14874 3.07299 2 3.42909 2 3.80039V12.2004C2 12.5717 2.14874 12.9278 2.4135 13.1903C2.67825 13.4529 3.03734 13.6004 3.41176 13.6004H8.35294C8.72736 13.6004 9.08645 13.4529 9.35121 13.1903C9.61597 12.9278 9.76471 12.5717 9.76471 12.2004V10.8004M5.52941 8.00039H14M14 8.00039L11.8824 5.90039M14 8.00039L11.8824 10.1004",
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogout04);
export default ForwardRef;